// @ts-nocheck
import { addTimezoneToMoment } from '@/shared/lib';
import dayjs from 'dayjs';
import { fabric } from 'fabric';
import _ from 'lodash';
import { DEFAULT_FONT } from '../../../config';

let TitleChart;

(function () {
  TitleChart = function ({
    canvas,
    verticalChannelPlacement,
    config,
    displayedChannelsArr,
    timeObject,
    startStudyDate,
    facilityCountry,
    facilityTimezone,
  }: any) {
    this.canvas = canvas;
    this.verticalChannelPlacement = verticalChannelPlacement;
    this.displayedChannelsArr = displayedChannelsArr;
    this.config = config;
    this.textTime = null;
    this.textTitle = null;
    this.textChannel = [];
    this.timeObject = timeObject;
    this.startStudyDate = startStudyDate;
    this.facilityCountry = facilityCountry;
    this.facilityTimezone = facilityTimezone;
    this.isEcgViewerTab = !_.isEmpty(this.timeObject);
    this.titleFont = {
      fill: '#1D2F47',
      fontFamily: DEFAULT_FONT,
      selectable: false,
      hasControls: false,
      hasBorders: false,
      hasRotatingPoint: false,
      selection: false,
      skipTargetFind: false,
      editable: false,
    };
  };

  TitleChart.prototype.update = function ({
    verticalChannelPlacement,
    config,
    displayedChannelsArr,
    timeObject,
    startStudyDate,
    facilityCountry,
    facilityTimezone,
  }: any) {
    this.verticalChannelPlacement = verticalChannelPlacement;
    this.displayedChannelsArr = displayedChannelsArr;
    this.config = config;
    this.timeObject = timeObject;
    this.startStudyDate = startStudyDate;
    this.facilityCountry = facilityCountry;
    this.facilityTimezone = facilityTimezone;
  };

  TitleChart.prototype.draw = function (offsetX: any, isAllStrip = false) {
    const { secondsToPix, indexToPix, recDuration } = this.config;

    let offsetStr = '';

    if (this.isEcgViewerTab) {
      const { startMoment, timezone, studyTimeOffset } = this.timeObject;
      const addedTimezoneStartMoment = addTimezoneToMoment({
        startStudyDate: this.startStudyDate,
        dateMoment: dayjs(startMoment),
        timezone,
        studyTimeOffset,
        facilityCountry: this.facilityCountry,
        facilityTimezone: this.facilityTimezone,
      });
      this.currentTime = (offsetX * indexToPix) / secondsToPix;
      const currentStartTimeMoment = addedTimezoneStartMoment.add(this.currentTime, 'seconds');
      const currentStartTimeStr = currentStartTimeMoment.format('HH:mm:ss');
      const currentStopTimeStr = currentStartTimeMoment
        .add(this.config.wndDuration, 'seconds')
        .format('HH:mm:ss');
      offsetStr = `${addedTimezoneStartMoment.format('MM/DD/YYYY')} ${currentStartTimeStr} - ${currentStopTimeStr}`;
    } else {
      this.currentTime = (offsetX * indexToPix) / secondsToPix;
      this.totalTime = recDuration;

      // *: For test purpose (3 cases)
      // this.currentTime = 3700;
      // this.totalTime = 4000;

      const currentTimeStr = this.getTimeInfo(this.currentTime);
      const totalTimeStr = this.getTimeInfo(this.totalTime);
      offsetStr = `${currentTimeStr} / ${totalTimeStr}`;
    }

    this.drawTime(offsetStr);

    const objectTitle = this.getTitle();
    this.drawTitle(objectTitle);

    this.drawChannel(isAllStrip);
  };

  TitleChart.prototype.drawTitle = function (objectTitle: any = {}) {
    const { height } = this.config;
    const { title, filterText } = objectTitle;
    const formatText = `${title}${filterText ? ` - ${filterText}` : ''}`;
    if (!this.textTitle) {
      this.textTitle = new fabric.IText(formatText, {
        ...this.titleFont,
        fontWeight: 400,
        fontSize: 16,
        left: 5,
        top: height - 24,
        hoverCursor: 'arrow',
      });
      this.canvas.add(this.textTitle);
    } else {
      this.textTitle.set({
        text: formatText,
        left: 5,
        top: height - 24,
        fontSize: 16,
      });
    }
  };

  TitleChart.prototype.drawChannel = function (isAllStrip: any) {
    const { majorDivSize, channelLabels, someChannelsHidden, speed } = this.config;
    let vertOffset = Math.min.apply(null, this.verticalChannelPlacement) / 2;
    vertOffset = Math.min(vertOffset, majorDivSize / 2);
    for (let j = 0; j < channelLabels.length; j += 1) {
      if (j < this.textChannel.length) {
        this.textChannel[j].set({
          text: channelLabels[j],
          left: 5,
          // *: Translate
          top:
            speed >= 25
              ? this.verticalChannelPlacement[j] - vertOffset
              : speed === 10
                ? this.verticalChannelPlacement[j] - vertOffset - 10
                : this.verticalChannelPlacement[j] - vertOffset - 25,
          visible: !isAllStrip,
          fontSize: 16,
        });
        this.textChannel[j].setCoords();
      } else {
        const channel = new fabric.IText(channelLabels[j], {
          ...this.titleFont,
          fontSize: 16,
          fontWeight: 700,
          fill: '#828C99',
          left: 5,
          top:
            speed >= 25
              ? this.verticalChannelPlacement[j] - vertOffset
              : speed === 10
                ? this.verticalChannelPlacement[j] - vertOffset - 10
                : this.verticalChannelPlacement[j] - vertOffset - 25,
          hoverCursor: 'arrow',
          fontFamily: DEFAULT_FONT,
        });
        this.textChannel.push(channel);
        this.canvas.add(channel);
      }
    }

    // *: Hide channel label
    if (someChannelsHidden) {
      for (let k = channelLabels.length; k < this.textChannel.length; k += 1) {
        this.textChannel[k].set({ visible: false });
      }
    }
  };

  TitleChart.prototype.drawTime = function (text: any) {
    const { height, width } = this.config;
    let widthTextTime =
      this.currentTime >= 3600 && this.totalTime >= 3600
        ? 220
        : this.currentTime < 3600 && this.totalTime >= 3600
          ? 200
          : 180;
    widthTextTime += 62;
    if (!this.textTime) {
      this.textTime = new fabric.IText(text, {
        ...this.titleFont,
        fontSize: 16,
        fontWeight: 400,
        width: widthTextTime,
        hoverCursor: 'arrow',
        left: width - widthTextTime - 5,
        top: height - 24,
      });
      this.canvas.add(this.textTime);
    } else {
      this.textTime.set({
        text,
        width: widthTextTime,
        fontSize: 16,
        left: width - widthTextTime - 5,
        top: height - 24,
      });
    }
  };

  TitleChart.prototype.getTimeInfo = function (timeSeconds: any) {
    const totalSeconds = timeSeconds;
    let remainSeconds = totalSeconds;

    // *: Get values to hours, minutes, seconds, milliseconds
    const hours = Math.floor(remainSeconds / 3600);
    remainSeconds -= hours * 3600;
    const minutes = Math.floor(remainSeconds / 60);
    remainSeconds -= minutes * 60;
    const seconds = Math.floor(remainSeconds);
    const milliSeconds = Math.floor((remainSeconds - seconds) * 1000);

    // *: Append '0' to the front of values if necessary
    const hoursText = `0${hours}`.slice(-2);
    const minutesText = `0${minutes}`.slice(-2);
    const secondsText = `0${seconds}`.slice(-2);
    const millisecondsText = `00${milliSeconds}`.slice(-3);

    let offsetText = '';
    if (totalSeconds >= 3600 || this.isEcgViewerTab) {
      offsetText += `${hoursText}:`;
    }
    offsetText += `${minutesText}:${secondsText}.${millisecondsText}`;

    return offsetText;
  };

  TitleChart.prototype.getTitle = function () {
    const { LFF, HFF, researchMode, hffOrder, bccHFF, bccMinSR, speed, gain } = this.config;
    let filterText = '';

    if (LFF > 0) {
      if (HFF > 0) {
        filterText += `HP: ${LFF.toString()}Hz, `;
      } else {
        filterText += `HP: ${LFF.toString()}Hz`;
      }
    }

    if (HFF > 0) {
      if (HFF === 50 || HFF === 60) {
        filterText += `LP: ${HFF}Hz - Notch`;
      } else {
        filterText += `LP: ${HFF.toString()}Hz`;
      }

      if (researchMode) {
        filterText += ` [N=${hffOrder}] [Nb=${bccHFF}][minSR=${bccMinSR}]`;
      }
    }

    // *: Round speed value
    const title = `${speed.toFixed(1).toString()}mm/s,${gain.toString()}mm/mV`;

    return { title, filterText };
  };

  TitleChart.prototype.updateData = function (config: any, timeObject: any) {
    this.isInDelMode = false;
    this.canvas.remove(this.delTitle);
    this.delTitle = null;
    this.config = config;
    this.timeObject = timeObject;
  };

  TitleChart.prototype.updateUploadedFile = function () {
    _.forEach(this.textChannel, (channel) => {
      this.canvas.remove(channel);
    });

    this.canvas.remove(this.textTitle);

    this.textChannel.length = 0;
    this.textTitle = null;
  };

  TitleChart.prototype.displayForAllStrip = function (isVisibility: any) {
    this.textTime.visible = isVisibility;
    this.textTitle.visible = isVisibility;
    for (let i = 0; i < this.textChannel.length; i += 1) {
      this.textChannel[i].visible = isVisibility;
    }
  };

  TitleChart.prototype.displayForViewLiveEcg = function ({
    isVisibilityTime = false,
    isVisibilityTitle = false,
    isVisibilityChannel = false,
  }) {
    this.textTime.visible = isVisibilityTime;
    this.textTitle.visible = isVisibilityTitle;
    for (let i = 0; i < this.textChannel.length; i += 1) {
      this.textChannel[i].visible = isVisibilityChannel;
    }
  };
})();

export { TitleChart };
export default { TitleChart };
